<div
    *ngIf="theme"
    class="agpr-themeCard agpr-contextMenu-parent"
    [ngClass]="
        expanded ? 'agpr-themeCard--expanded' : 'agpr-themeCard--collapsed'
    "
    [@containerState]="{
        value: expanded ? 'expanded' : 'collapsed',
        params: { cardHeight: cardHeight }
    }"
    (@containerState.done)="onToggleDone()"
    (click)="cardClicked()"
    role="group"
    [attr.aria-label]="theme.name"
    tabindex="0"
>

    @if (!expanded) {
        <span class="agpr-themeCard-header">
            @if (theme.avatarUrl) {
                <img
                    class="agpr-themeCard-image"
                    alt=""
                    [src]="theme.avatarUrl"
                />
            } @else {
                <div
                    class="agpr-themeCard-imagePlaceholder"
                    [style.color]="theme.avatarPlaceholderColor"
                    [style.background-color]="theme.avatarPlaceholderBackgroundColor"
                >
                    <span aria-hidden="true">{{ theme.avatarPlaceholderText }}</span>
                </div>
            }
            <span class="agpr-themeCard-name">{{ theme.name }}</span>
            <!-- An automation agent is watching this theme - as marked in the monitoring sidebar -->
            @if (liveAgentCount) {
                <span
                    role="img"
                    class="agpr-themeCard-liveAgentIcon fa-solid fa-signal-stream"
                    [agprTooltip]="liveAgentTooltip"
                    tooltipPosition="top"
                    [attr.aria-label]="liveAgentTooltip"
                ></span>
            }
        </span>
        <div class="agpr-themeCard-sideWrapper">
            @if (isThemePartiallyModerated) {
                <span
                    role="img"
                    class="agpr-themeCard-sideWrapper-error fa-solid fa-circle-exclamation"
                    agprTooltip="Social.intelligence.themeManagement.themeCard.partiallyModerated.tooltip"
                    tooltipPosition="top"
                    [attr.aria-label]="'Social.intelligence.themeManagement.themeCard.partiallyModerated.tooltip' | localize"
                ></span>
            }

            <agpr-button
                [id]="'themeCard_' + theme.id + '_toggleButton'"
                class="agpr-themeCard-toggleButton"
                [style]="buttonTypes.link"
                ariaLabel="Social.intelligence.themeManagement.themeCard.toggleButton.ariaLabel"
                tooltip="Social.intelligence.themeManagement.themeCard.toggleButton.ariaLabel"
                [expanded]="expanded"
                (click)="toggleThemeCard()"
            >
                <span class="agpr-themeCard-sideWrapper-amount">
                    {{ themeAgents.length }}
                    {{
                        themeAgents
                            ? ((themeAgents.length === 1
                                ? "Social.intelligence.themeManagement.agent"
                                : "Social.intelligence.themeManagement.agents"
                            ) | localize)
                            : ""
                    }}
                </span>
                <span class="fa-solid fa-angle-down agpr-themeCard-sideWrapper-expandIcon" aria-hidden="true"></span>
            </agpr-button>
        </div>
    } @else {
        <!-- expanded theme -->
        <div class="agpr-themeCard-themeInfo">
            <div class="agpr-themeCard-header--expanded">
                <div class="agpr-themeCard-imageWrapper">
                    @if (theme.avatarUrl) {
                        <img
                            class="agpr-themeCard-image"
                            [alt]="theme.name"
                            [src]="theme.avatarUrl"
                        />
                    } @else {
                        <div
                            class="agpr-themeCard-imagePlaceholder"
                            [style.color]="theme.avatarPlaceholderColor"
                            [style.background-color]="theme.avatarPlaceholderBackgroundColor"
                        >
                            <span>{{ theme.avatarPlaceholderText }}</span>
                        </div>
                    }

                    <agpr-content-library-panel
                        [id]="'themeCard_' + theme.id"
                        [config]="contentLibrary"
                        [field]="contentLibraryField"
                        [socialTheme]="true"
                        (changes)="updateThemeImage($event)"
                    ></agpr-content-library-panel>
                </div>
                <div class="agpr-themeCard-name">
                    @if (!isEditingName) {
                        <span
                            class="agpr-themeCard-nameLabel"
                            [agprTooltip]="theme.name"
                            [initiallyFocusable]="false"
                            tooltipPosition="top"
                        >
                            {{ theme.name }}
                        </span>
                    } @else {
                        <agpr-text-input
                            [id]="'themeCard_' + theme.id + '_renameThemeTextField'"
                            placeholder="Social.intelligence.themeManagement.themeCard.editName.placeholder"
                            [(ngModel)]="themeNameClone"
                            [initialHighlight]="true"
                            ariaLabel="Social.intelligence.themeManagement.themeCard.editName.placeholder"
                            [maxLength]="256"
                            [bottomMargin]="false"
                            (blur)="doneEditingName()"
                        ></agpr-text-input>
                    }

                    <div class="agpr-themeCard-nameMenu">
                        @if (!isEditingName) {
                            <agpr-button
                                [id]="'themeCard_' + theme.id + '_renameThemeButton'"
                                icon="fa-regular fa-duotone fa-pen"
                                [style]="buttonTypes.icon"
                                tooltip="Social.intelligence.themeManagement.themeCard.editName"
                                tooltipPosition="top"
                                (click)="editNameClicked()"
                            ></agpr-button>
                        }
                        <agpr-button
                            [id]="'themeCard_' + theme.id + '_deleteThemeButton'"
                            icon="fa-regular fa-duotone fa-trash-can"
                            [style]="buttonTypes.icon"
                            tooltip="Social.intelligence.themeManagement.themeCard.deleteTheme"
                            tooltipPosition="top"
                            (click)="deleteThemeClicked()"
                        ></agpr-button>
                    </div>
                </div>
            </div>
            <div class="agpr-themeCard-addAgent">
                <span class="agpr-themeCard-addAgent-heading">
                    {{ "Social.intelligence.themeManagement.themeCard.addAgent" | localize }}
                </span>
                <span
                    role="img"
                    class="fa-regular fa-circle-info agpr-themeCard-addAgent-tooltip"
                    agprTooltip="Social.intelligence.themeManagement.themeCard.addAgent.tooltip"
                ></span>
                <div class="agpr-themeCard-addAgent-toolbar">
                    <div class="agpr-themeCard-existingTopicDropdown">
                        <agpr-dropdown
                            [label]="'Social.intelligence.themeManagement.themeCard.addAgent.chooseExisting'"
                            [id]="'themeCard_' + theme.id + '_existingAgentDropdown'"
                            [options]="availableAgentsToAdd"
                            [disabled]="themeAgents.length >= AGENT_MAX"
                            placeholder="Social.intelligence.themeManagement.themeCard.addAgent.dropdown.placeholder"
                            [inputTooltip]="
                                themeAgents.length >= AGENT_MAX
                                    ? ('Social.intelligence.themeManagement.themeCard.addAgent.maxReached' | localize: { max: AGENT_MAX })
                                    : null
                            "
                            [keepSelectedValue]="false"
                            [agprStyle]="agprComponentStyle.social"
                            (change)="addAgentToTheme($event)"
                        ></agpr-dropdown>
                    </div>
                    <div class="agpr-themeCard-manageAgentButton">
                        <agpr-button
                            [id]="'themeCard_' + theme.id + '_manageAgentButton'"
                            icon="fa-regular fa-duotone fa-gear"
                            [tooltip]="
                                themeAgents.length >= AGENT_MAX
                                    ? ('Social.intelligence.themeManagement.themeCard.addAgent.maxReached' | localize: { max: AGENT_MAX })
                                    : 'Social.intelligence.themeManagement.themeCard.addAgent.manageAgents'
                            "
                            [style]="buttonTypes.block"
                            (click)="openManageAgentDialog()"
                        ></agpr-button>
                    </div>
                </div>
                <agpr-button
                    [id]="'themeCard_' + theme.id + '_createAgentButton'"
                    [ariaLabel]="'Social.intelligence.themeManagement.themeCard.addAgent.createAgent' | localize"
                    [style]="buttonTypes.secondary"
                    [disabled]="themeAgents.length >= AGENT_MAX"
                    [tooltip]="
                        themeAgents.length >= AGENT_MAX
                            ? ('Social.intelligence.themeManagement.themeCard.addAgent.maxReached' | localize: { max: AGENT_MAX })
                            : null
                    "
                    (click)="openCreateAgentTakeOver()"
                >{{'Social.intelligence.themeManagement.themeCard.addAgent.createAgent' | localize}}</agpr-button>
            </div>
        </div>
        <div class="agpr-themeCard-toggleButton--expanded">
            <agpr-button
                [id]="'themeCard_' + theme.id + '_expandedToggleButton'"
                class="agpr-themeCard-toggleButton"
                icon="fa-solid fa-angle-up"
                [style]="buttonTypes.icon"
                tooltip="Social.intelligence.themeManagement.themeCard.toggleButton.ariaLabel"
                [expanded]="expanded"
                (click)="toggleThemeCard()"
            ></agpr-button>
        </div>
        @if (themeAgents.length > 0) {
            <div class="agpr-themeCard-agentTable">
                <div class="agpr-themeCard-agentTableHeader">
                    <div> {{ 'Social.intelligence.themeManagement.agents' | localize }} </div>
                    <div>
                        {{ 'Social.intelligence.themeManagement.usage' | localize }}
                        <span
                            role="img"
                            class="fa-regular fa-circle-info agpr-themeCard-agentTableHeader-tooltip"
                            agprTooltip="Social.intelligence.themeManagement.usage.tooltip"
                            tooltipPosition="top"
                            [attr.aria-label]="'Social.intelligence.themeManagement.usage.tooltip' | localize"
                        ></span>
                    </div>
                </div>
                <ul>
                    @for (agent of themeAgents; track agent.id; let rowIndex = $index) {
                        <li
                            class="agpr-themeCard-agentTable-row"
                            (click)="openCreateAgentTakeOver(agent)"
                        >
                            <div class="agpr-themeCard-agentTable-agent">
                                <agpr-social-topic-status-switch
                                    class="agpr-themeCard-agentTable-switchButton"
                                    [id]="'themeCard_' + theme.id + '_agent_' + agent.id + '_statusButton'"
                                    [initiallyFocusable]="true"
                                    [ngModel]="agent.status"
                                    (ngModelChange)="statusChange($event, agent)"
                                    [isPartiallyModerated]="agent.isPartiallyModerated"
                                    [agentName]="agent.name"
                                    [partiallyModeratedTooltip]="'Social.intelligence.themeManagement.themeCard.partiallyModerated' | localize: {
                                        rowName: agent.name,
                                        moderatedNetworks: agent.partiallyModeratedNetworks
                                    }"
                                    [disabled]="agent.mediaTypeRequests?.length === 0"
                                    [disabledTooltip]="'Social.agentWidget.error.noNetwork'"
                                ></agpr-social-topic-status-switch>
                                <span
                                    class="agpr-themeCard-agentTable-name"
                                    [pTooltip]="agent.name"
                                    tooltipPosition="top"
                                >
                                    {{ agent.name }}
                                </span>
                            </div>
                            <div
                                class="agpr-themeCard-agentTable-usage"
                                (click)="openCreateAgentTakeOver(agent)"
                            >
                                @let quotaUseage = getQuotaUsageRate(agent.id);
                                <span
                                    role="img"
                                    [class]="'agpr-themeCard-agentTable-quotaUsageIndicator ' + quotaUsageToIconClassMap.get(quotaUseage)"
                                    [agprTooltip]="'Social.intelligence.themeManagement.themeCard.quotaUsageIndicator.tooltip.' + quotaUseage | localize"
                                    tooltipPosition="top"
                                ></span>
                                <span class="agpr-themeCard-agentTable-usageValue">
                                    {{ getQuotaData(agent.id) }}
                                </span>
                                <div class="agpr-themeCard-agentTable-usageChart">
                                    <agpr-chart
                                        [chart]="getChartData(agent.id)"
                                        [smallIndicator]="true"
                                    ></agpr-chart>
                                </div>
                                <agpr-split-button
                                    class="agpr-themeCard-agentTable-splitButton"
                                    [id]="'agent_' + agent.id + '_Actions'"
                                    [style]="buttonTypes.icon"
                                    [showTriggerIcon]="false"
                                    icon='fa-light fa-ellipsis-vertical'
                                    [options]="agentOptions"
                                    [data]="agent"
                                    [panelPositionY]="themeAgents.length < 3 || rowIndex < themeAgents.length - 2 ? 'bottom' : 'top'"
                                    panelPositionX="right"
                                ></agpr-split-button>
                            </div>
                        </li>
                    }
                </ul>
            </div>
        } @else {
            <div class="agpr-themeCard-noAgentPlaceholder">
                <button
                    [id]="'themeCard_' + theme.id + '_createFirstAgentButton'"
                    class="agpr-themeCard-createFirstAgent"
                    (click)="openCreateAgentTakeOver()"
                    [ariaLabel]="'Social.intelligence.themeManagement.themeCard.noAgent.action' | localize"
                >
                    {{"Social.intelligence.themeManagement.themeCard.noAgent.action" | localize}}
                </button>
                <span>
                    {{ "Social.intelligence.themeManagement.themeCard.noAgent.message" | localize }}
                </span>
            </div>
        }
    }

    <div class="agpr-contextMenu bottom right">
        @if (hasAgenticFeature) {
            <agpr-button
                [id]="'themeCard_' + theme.id + '_manageAutomationAgentsButton'"
                class="agpr-themeCard-contextMenu-button"
                icon="fa-kit-duotone fa-agpr-ai-generic"
                ariaLabel="AutomationAgents.source.addLiveAgent"
                tooltip="AutomationAgents.source.addLiveAgent"
                tooltipPosition="top"
                [style]="buttonTypes.contextMenu"
                (click)="manageAutomationAgents($event)"
            ></agpr-button>
        }
        <agpr-button
            class="agpr-themeCard-contextMenu-button"
            icon="fa-regular fa-duotone fa-eye"
            ariaLabel="Social.intelligence.themeManagement.themeCard.viewTheme.ariaLabel"
            (click)="goToTheme()"
            tooltip="Social.intelligence.themeManagement.themeCard.viewTheme.tooltip"
            tooltipPosition="top"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
    </div>
</div>
